import { Component } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {encodingClothsImages} from '../cloths-mockup';
import {encodingHalfSymbolsImages, encodingSymbolsImages} from '../symbols-mockup';

@Component({
  selector: 'app-defect-encoding',
  templateUrl: './defect-encoding.component.html',
  styleUrls: ['./defect-encoding.component.css']
})
export class DefectEncodingComponent extends GeneralExerciseComponent {

  encodings: number[][] = [];
  defectEncoding: number[] = [];
  symbolImages = encodingSymbolsImages;
  halfSymbolImages = encodingHalfSymbolsImages;
  clothsImages = encodingClothsImages;
  solutionImageIdx = -1;
  clickedValues: number[] = [];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
    this.encodings = [];
    this.defectEncoding = [];
    this.solutionImageIdx = -1;
    this.clickedValues = [];
  }

  checkSolution() {
    const tempIdx = this.getSolutionIdx();
    const idx1 = tempIdx[0];
    const idx2 = tempIdx[1];

    if (idx1 !== -1 && idx2 !== -1) {
      if (this.clickedValues[this.clickedValues.length - 1] !== idx1 && this.clickedValues[this.clickedValues.length - 1] !== idx2) {
        this.clickedValues.pop();
        this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
      }

      for (let i = 0; i < this.clickedValues.length; i++) {
        if (this.clickedValues[i] === idx1) {
          this.solutionImageIdx = 0;
        }
        if (this.clickedValues[i] === idx2) {
          this.solutionImageIdx = 1;
        }
      }

      if (this.clickedValues.length === 2) {
        this.solutionImageIdx = 2;
        this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
        this.isSolvedImageVisible = true;
        this.solved = true;
        setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        this.saveState();
      }
    } else {
      if (idx1 !== -1 && this.clickedValues[0] === idx1) {
        this.solutionImageIdx = 0;
        this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
        this.isSolvedImageVisible = true;
        this.solved = true;
        setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        this.saveState();
      } else if (idx2 !== -1 && this.clickedValues[0] === idx2) {
        this.solutionImageIdx = 1;
        this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
        this.isSolvedImageVisible = true;
        this.solved = true;
        setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        this.saveState();
      } else {
        this.clickedValues.pop();
        this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
      }
    }
  }

  generateNextExercise() {
    this.initValues();
    this.counter ++;
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }

  setEncoding(encodings: number[][]) {
    this.encodings = encodings;
  }

  setDefectEncoding(defectEncoding: number[]) {
    this.defectEncoding = defectEncoding;
  }

  setClickedValues(idx: number) {
    if (this.clickedValues.indexOf(idx) === -1) {
      this.clickedValues.push(idx);
      this.checkSolution();
    }
  }

  getSymbolImage(idx: number) {
   if (idx === -1 && this.solved === false) {
      if (this.solutionImageIdx !== -1) {
        return this.halfSymbolImages[this.solutionImageIdx];
      } else {
        return './assets/images/encoding/openQuestion.png';
      }
    }

    if (idx === -1 && this.solved === true) {
      if (this.solutionImageIdx === 2) {
        return this.halfSymbolImages[2];
      } else {
        return this.symbolImages[this.solutionImageIdx];
      }
    }
    return this.symbolImages[idx];
  }

  getClothsImage(idx: number) {
    return this.clothsImages[idx];
  }

  getCodeWidth() {
    const width = 100 / this.defectEncoding.length;
    return width.toString() + '%';
  }

  getSolutionIdx() {
    const temp1 = [];
    const temp2 = [];
    for (let i = 0; i < this.defectEncoding.length; i++) {
      if (this.defectEncoding[i] !== -1) {
        temp1[i] = this.defectEncoding[i];
        temp2[i] = this.defectEncoding[i];
      } else {
        temp1[i] = 0;
        temp2[i] = 1;
      }
    }

    const idx1 = this.encodings.findIndex(i => this.compareArrays(i, temp1));
    const idx2 = this.encodings.findIndex(i => this.compareArrays(i, temp2));

    return [idx1, idx2];
  }
}
